import create from "zustand";

const useModalDataStore = create((set: any) => ({
    modalData: {},
    setModalData: (data: object) => set(() => ({ modalData: data })),
    modalData2: {},
    setModalData2: (data: object) => set(() => ({ modalData2: data })),
}));

export { useModalDataStore };
